<template>
  <div class="app-consumption-list">
    <ConsumptionItem v-for="consumption in consumptions"
                     :key="consumption.type"
                     :tariff-id="tariffId"
                     :consumption="consumption"
    :consumption-title="consumptionTitle">
      <template v-for="slot in possibleChildSlotsFor('Item')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsumptionItem>
  </div>
</template>

<script>

import slotProxy from '../../../../../mixins/slotProxy'

export const stepName = 'view'
export default {
  mixins: [
    slotProxy()
  ],
  props: {
    consumptions: {
      type: Array,
      default: () => []
    },
    tariffId: {
      type: String,
      default: ''
    },
    consumptionTitle: {
      type: Boolean,
      default: true
    }
  },
  name: 'ConsumptionList'
}
</script>
